<!--
/**
* @name: List.vue
* @description: 余额变动申请导入
* @author: 杨波
* @create: 2020/12/21 15:22:33
* @update: 2020/12/21 15:22:33
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false" @search="onSearch">
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入任务编号" clearable v-model="para.artificialImportNo"></k-input>
      </y-query-item>
      <y-query-item>
        <DatePicker :editable="false" type="datetimerange" @on-change="changeDate" :value="effectDate" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择导入时间" style="width: 280px;"></DatePicker>
      </y-query-item>
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择记录状态" clearable v-model="para.status">
          <k-option v-for="item in statusList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
      <y-query-item slot="right">
        <k-button @click="onDownLoad">下载模板</k-button>
      </y-query-item>
      <y-query-item slot="right">
        <k-button type="primary" @click="onImport">导入</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="recordList" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="getRecordList" />
    <k-popup :okLoading="okLoading" :show.sync="isShowImport" title="导入余额变动申请" okText="确认导入" @after-cancel="onCancelPopup" @after-ok="onSave">
      <y-popup-body size="small">
        <y-form titleWidth="90px" titleAlign="left">
          <y-form-item title="选择文件：">
            <y-upload-file title="请上传模板" acceptType=".xls,.xlsx" :uploadUrl="uploadUrl" @uploaded="onUploaded"></y-upload-file>
            <k-icon class="k-icon-success" color="#999" style="display: inline-block; position: absolute; left: 205px;" v-if="isUploadSuccess"></k-icon>
          </y-form-item>
        </y-form>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>

<script>
import {
  NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_IMPORT_LIST,
  NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_PRE_IMPORT,
  NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_DISCARD_IMPORT,
  NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_ACCEPT_IMPORT,
  NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_TEMPLATE,
  NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_IMPORT_LIST_OPTIONS,
  NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
} from "@/assets/modules/apiList";

const initPara = () => ({
  createStartTime: "",
  createEndTime: "",
  artificialImportNo: "",
  status: "",
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      recordList: [],
      para: initPara(),
      importUrl: "",
      total: 0,
      isLoading: false,
      isShowImport: false,
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
      effectDate: "",
      isUploadSuccess: false,
      statusList: [],
      okLoading: false,
    };
  },
  computed: {
    createStartTime() {
      return this.effectDate[0];
    },
    createEndTime() {
      return this.effectDate[1];
    },
  },
  methods: {
    initColumns() {
      return [
        {
          name: "任务编号",
          field: "artificialImportNo",
          style: {
            width: 180,
            textAlign: "center",
          },
          customRender: (row) => {
            const viewLogButton = <a href="javascript:void(0);">{row.artificialImportNo}</a>;

            return <div>{viewLogButton}</div>;
          },
        },
        {
          name: "记录数量",
          field: "totalCount",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "已导入数量",
          field: "importedCount",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "有效记录",
          field: "validCount",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "已审核数量",
          field: "acceptedCount",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "导入时间",
          field: "createTime",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
        {
          name: "记录状态",
          field: "status",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => {
            return (
              <div>
                <span class={row.status == "1" ? this.css.enabled : row.status == "2" ? this.css.deleted : row.status == "3" ? this.css.disabled : this.css.doing}></span>
                <span>{row.statusDesc}</span>
              </div>
            );
          },
        },
        {
          name: "操作",
          field: "",
          style: {
            width: 100,
            textAlign: "center",
          },
          customRender: (row) => {
            const viewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row);
                }}
              >
                查看
              </a>
            );
            const auditButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onAudit(row);
                }}
              >
                审核
              </a>
            );
            const cancelButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onCancel(row);
                }}
              >
                作废
              </a>
            );
            if (row.status == "1" && !row.validCount) {
              return <div>{viewButton}</div>;
            } else if (row.status == "1" && row.validCount) {
              return (
                <div>
                  {viewButton}&#12288;{auditButton}&#12288;{cancelButton}
                </div>
              );
            } else {
              return <div>{viewButton}</div>;
            }
          },
        },
      ];
    },
    onDownLoad() {
      this.$fetch({
        api: NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_TEMPLATE,
        para: {},
        isBlob: true,
        filename: "余额变动申请",
      })
        .then((res) => {})
        .catch(() => {});
    },
    changeDate(date) {
      this.effectDate = date;
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getRecordList();
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getRecordList();
    },
    onView(row) {
      const { id } = row;
      this.$controller.open({
        name: "surplusImportDetailManagement",
        query: {
          refresh: new Date() - 0,
          id,
        },
      });
    },
    onReset() {
      this.para = initPara();
      this.effectDate = "";
      this.getRecordList();
    },
    onAudit(row) {
      this.$dialog({
        title: "提示",
        content: "是否确认审核此申请？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_ACCEPT_IMPORT,
            para: { id: row.id },
          })
            .then((res) => {
              this.getRecordList();
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onCancel(row) {
      this.$dialog({
        title: "提示",
        content: "是否确认作废当前申请？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_DISCARD_IMPORT,
            para: { id: row.id },
          })
            .then((res) => {
              this.getRecordList();
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onUploaded(data) {
      let { tip } = this.$root;
      this.importUrl = data.data[0].url;
      this.isUploadSuccess = true;
      tip("文件上传成功");
    },
    onCancelPopup() {
      this.isUploadSuccess = false;
    },
    onSave() {
      let { tip } = this.$root;
      this.okLoading = true;
      this.$fetch({
        api: NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_PRE_IMPORT,
        para: { fileUrl: this.importUrl },
      })
        .then((res) => {
          tip("导入成功");
          this.getRecordList();
          this.isShowImport = false;
          this.isUploadSuccess = false;
          this.okLoading = false;
        })
        .catch(() => {
          this.okLoading = false;
        });
    },
    onImport() {
      this.isUploadSuccess = false;
      this.isShowImport = true;
    },
    getRecordList() {
      let { para } = this;
      para.createStartTime = this.effectDate && this.effectDate.length > 0 ? this.effectDate[0] : "";
      para.createEndTime = this.effectDate && this.effectDate.length > 0 ? this.effectDate[1] : "";
      this.$fetch({
        api: NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_IMPORT_LIST,
        para,
      }).then((res) => {
        this.recordList = res.pageList;
        this.total = res.total;
      });
    },
    getStatusList() {
      this.$fetch({
        api: NESTLE_FINANCE_BACK_SERVER_ARTIFICIAL_IMPORT_LIST_OPTIONS,
        para: {},
      }).then((res) => {
        this.statusList = res.statuses || [];
      });
    },
  },
  created() {
    this.getRecordList();
    this.getStatusList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getRecordList();
    next();
  },
};
</script>

<style lang="postcss" module="css">
.inputW {
  width: 230px !important;
}
.enabled {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #1890ff;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
.disabled {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #f5222d;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
.deleted {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #52c41a;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
.doing {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #ffba18;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
</style>
